<template>
  <form-group>
    <v-row justify="start">
      <v-col cols="6">
        <skeleton
          width="100"
          height="30"
        />
      </v-col>
    </v-row>
    <v-row class="pt-3">
      <v-col cols="12">
        <skeleton
          width="100%"
          height="300"
        />
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import Skeleton from '@/app/arch/components/global-components/Skeleton.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';

export default {
  name: 'UserProductStoreContentShimmer',
  components: { Skeleton, FormGroup },
};
</script>
